import Vue from 'vue';
import App from './App.vue';
import CludoVue from '@universityofbristol/cludo-vue';
import store from './store';

Vue.config.productionTip = false;
const mountEl = document.getElementById('ug-programme-search');
const year = mountEl.dataset.year;


Vue.use(CludoVue, {
  store: store,
  options: {
    useQuery: true,
    cludoCustomerId: 2541,
    cludoEngineId: 12211,
    // cludoEngineId: 11278, // Course/Programme Engine ID
    queryStatsEnabled: true,
    clickStatsEnabled: true,
    perPage: 500,
    paginationRange: 2,
    sortOnLoad: { Title: 'asc' },
    payload: {
      filters: {
        Category: ['Undergraduate'],
        StudyLevel: ['Undergraduate'],
        StudyYear: ['2026', '2027'],
      },
      // postFiltersOperator: 'or',
    },
  },
});

new Vue({
  render: (h) =>
    h(App, {
      props: {
        year: year,
      },
    }),
  store: store,
}).$mount('#ug-programme-search');
